(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["uq-celeb-landing"]) return;
  try {
    

  $('#celebLandingContactBtn').on('click', function() {
    var myHeaders = new Headers();
    myHeaders.append("Api-Key", "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");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "sender": {
        "name": "Sender",
        "email": "info@uniquen.com"
      },
      "to": [
        {
          "email": "jegasmlm@gmail.com",
          "name": "Receiver"
        }
      ],
      "subject": "Hello world",
      "htmlContent": "<html><head></head><body><p>Hello,</p>This is my first transactional email sent from Sendinblue.</p></body></html>"
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://api.sendinblue.com/v3/smtp/email", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uq-masterclass-product"]) return;
  try {
    

  $('.cta').on('click', function() {
      $('#real_cta').click();
  });

  window.addEventListener("load", function() {

    var playbtns = document.querySelectorAll('.play-btn');

    for(var i=0; i < playbtns.length; i++ ) {
                                    
      playbtns[i].addEventListener("click", function(e) {
        var videoId = '#'+e.target.parentElement.dataset.video + ' video';
        var video = document.querySelector(videoId);

        if(!video.classList.contains("playing")){
          video.play();

          video.classList.add("playing");

          e.target.parentElement.classList.add("stop-btn");
        } else {
          video.load();

          video.classList.remove("playing");

          e.target.parentElement.classList.remove("stop-btn");
        }
      })
                                    
    }  
 });

  $(document).ready(function() {

      var productId = $('.celeb-info').attr('data-productid');
	  console.debug('[celeb-info]', productId);

      getMPProfile(productId, function(profile){

        $('#seller_detail_logo_img').attr('src', profile.sellProfileCallback.logo);
      	$('#vendor-title').html(profile.sellProfileCallback.sp_store_name);
        $('#product-vendor').html(profile.sellProfileCallback.sp_store_name);
	
        /*$('#vendor-title').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });

	
        $('#seller_detail_logo_img').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });*/
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uq-product-celeb-info"]) return;
  try {
    

  $(document).ready(function() {

      var productId = $('.celeb-info').attr('data-productid');
	  console.debug('[celeb-info]', productId);

      getMPProfile(productId, function(profile){

        $('#seller_detail_logo_img').attr('src', profile.sellProfileCallback.logo);
      	$('#vendor-title').html(profile.sellProfileCallback.sp_store_name);
        $('#product-vendor').html(profile.sellProfileCallback.sp_store_name);
	
        /*$('#vendor-title').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });

	
        $('#seller_detail_logo_img').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });*/
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uq-product"]) return;
  try {
    

  $(document).ready(function() {
    var productImages = document.querySelectorAll(".uq-product-image-item img");
    productImages.forEach(function(productImage) {
      productImage.addEventListener("click", function() {
        document.querySelector(".uq-product-image img").src= productImage.src;
      });
    });
  });

  $(document).ready(function() {

      var productId = $('.celeb-info').attr('data-productid');
	  console.debug('[celeb-info]', productId);

      getMPProfile(productId, function(profile){

        $('#seller_detail_logo_img').attr('src', profile.sellProfileCallback.logo);
      	$('#vendor-title').html(profile.sellProfileCallback.sp_store_name);
        $('#product-vendor').html(profile.sellProfileCallback.sp_store_name);
	
        /*$('#vendor-title').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });

	
        $('#seller_detail_logo_img').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });*/
      });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uq-video-product"]) return;
  try {
       
  window.addEventListener("load", function() {

    var playbtns = document.querySelectorAll('.play-btn');

    for(var i=0; i < playbtns.length; i++ ) {
                                    
      playbtns[i].addEventListener("click", function(e) {
        var videoId = '#'+e.target.parentElement.dataset.video + ' video';
        var video = document.querySelector(videoId);
        if(!video.classList.contains("playing")){
          video.play();
          video.classList.add("playing");
          playbtns[i].classList.add("stop-btn");
        } else {
          video.load();
          video.classList.remove("playing");
          playbtns[i].classList.remove("stop-btn");
        }
      })
                                    
    }  
 });

  $(document).ready(function() {

      var productId = $('.celeb-info').attr('data-productid');
	  console.debug('[celeb-info]', productId);

      getMPProfile(productId, function(profile){

        $('#seller_detail_logo_img').attr('src', profile.sellProfileCallback.logo);
      	$('#vendor-title').html(profile.sellProfileCallback.sp_store_name);
        $('#product-vendor').html(profile.sellProfileCallback.sp_store_name);
	
        /*$('#vendor-title').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });

	
        $('#seller_detail_logo_img').on('click', function() {
            window.location = '/collections/'+profile.sellProfileCallback.store_name_handle;
        });*/
      });
  });

  } catch(e) { console.error(e); }
})();

})();
